/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=30d7766c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=30d7766c&lang=less"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__